import type { HttpClient, Result } from '@/lib/http/HttpClient';
import type {
  AdaptcutToolsResponse,
  WearQuery,
  WearResponse,
  WearSaveQuery,
  WearSaveResponse,
} from '../type/WearTypes';

/**
 * Tool wear routes (machine_learning module) and the Adaptcut tool list used to
 * fill the cutting diameter (Adaptcut module: other users get a 403).
 */
export class WearApiClient {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  read(query: WearQuery, signal?: AbortSignal): Promise<Result<WearResponse>> {
    return this.http.post<WearResponse>(
      '/api/machine-learning/wear/read',
      query,
      signal ? { signal } : undefined
    );
  }

  save(query: WearSaveQuery): Promise<Result<WearSaveResponse>> {
    return this.http.post<WearSaveResponse>('/api/machine-learning/wear/write', query);
  }

  adaptcutTools(signal?: AbortSignal): Promise<Result<AdaptcutToolsResponse>> {
    return this.http.post<AdaptcutToolsResponse>(
      '/api/adaptcut-connector/tools/readAll',
      {},
      signal ? { signal } : undefined
    );
  }
}
